export enum PriceTypes {
  NET_PRICE = 'NetPrice',
  FINAL_PRICE = 'FinalPrice',
  MONEY = 'Money',
}
